var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.timeSaleShow
    ? _c(
        "div",
        { staticClass: "popup", attrs: { id: "timeSaledPopup" } },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.contentShow,
                  expression: "contentShow"
                }
              ],
              staticClass: "timesale-content",
              class: "saled-bg-" + _vm.lang,
              style: "transform: scale(" + _vm.screenWidthRatio + ");",
              attrs: { id: "timeSaled", name: "timeSaledPopup" }
            },
            [
              _c("div", { staticClass: "timesale-top-close" }, [
                _c("div", {
                  staticClass: "discount_close",
                  staticStyle: { float: "center" },
                  on: {
                    click: function($event) {
                      return _vm.closePage()
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "discount_close-bg" }),
              _vm._v(" "),
              _c("div", { staticClass: "timesale-body" }, [
                _c("div", { staticClass: "timesale-schemes" }, [
                  _c("div", { staticClass: "timesale-scheme" }, [
                    _c("div", { staticClass: "timesale-scheme-title" }, [
                      _c("div", [
                        _vm._v(
                          _vm._s(
                            "- " +
                              _vm.$t("language.paySystem.limitedData") +
                              " -"
                          )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    !_vm.user.vip
                      ? _c(
                          "div",
                          {
                            staticClass: "timesale-scheme-body",
                            style: _vm.getHeight()
                          },
                          [
                            _c("div", { staticClass: "timesale-scheme-left" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "scheme-discount",
                                  style: _vm.getDiscountLeft(
                                    _vm.schemes[0].title,
                                    266
                                  )
                                },
                                [
                                  _vm._v("-" + _vm._s(_vm.schemes[0].discount)),
                                  _c("span", [_vm._v("%")])
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "scheme-title" }, [
                                _vm._v(_vm._s(_vm.schemes[0].title))
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "scheme-price" }, [
                                _c("span", { staticClass: "price" }, [
                                  _vm.currency[_vm.priceLang].front
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.currency[_vm.priceLang].front
                                          )
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(
                                        _vm.schemes[0].price[_vm.priceLang]
                                      ) +
                                      "\n                                    "
                                  ),
                                  _vm.currency[_vm.priceLang].after
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.currency[_vm.priceLang].after
                                          )
                                        )
                                      ])
                                    : _vm._e()
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "price-old" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.schemes[0].oldPrice[_vm.priceLang]
                                    )
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "scheme-type" }, [
                                _vm._v(_vm._s(_vm.schemes[0].type))
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "scheme-btn" }, [
                                _c(
                                  "button",
                                  {
                                    on: {
                                      click: function($event) {
                                        return _vm.openPage(0, _vm.schemes[0])
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "language.popup.worldBackupPopup.getOffer"
                                        )
                                      )
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "scheme-tips" }, [
                                _c("div", { staticClass: "scheme-tip" }, [
                                  _c("div", { staticClass: "point" }),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.schemes[0].tip) +
                                        "\n                                        "
                                    ),
                                    _c("div", { staticClass: "ask" }, [
                                      _c(
                                        "div",
                                        { staticClass: "plan-questionTxt" },
                                        [_vm._v(_vm._s(_vm.schemes[0].tipPs))]
                                      )
                                    ])
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "scheme-tip" }, [
                                  _c("div", { staticClass: "point" }),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "language.popup.worldBackupPopup.tips1"
                                        )
                                      ) +
                                        "\n                                        "
                                    ),
                                    _c("div", { staticClass: "ask" }, [
                                      _c(
                                        "div",
                                        { staticClass: "plan-questionTxt" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "language.popup.worldBackupPopup.ps1"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ])
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "scheme-tip" }, [
                                  _c("div", { staticClass: "point" }),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "language.popup.worldBackupPopup.tips2"
                                        )
                                      ) +
                                        "\n                                        "
                                    ),
                                    _c("div", { staticClass: "ask" }, [
                                      _c(
                                        "div",
                                        { staticClass: "plan-questionTxt" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "language.popup.worldBackupPopup.ps2"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ])
                                  ])
                                ])
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "timesale-scheme-line" }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "timesale-scheme-right" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "scheme-discount",
                                    style: _vm.getDiscountLeft(
                                      _vm.schemes[1].title,
                                      266
                                    )
                                  },
                                  [
                                    _vm._v(
                                      "-" + _vm._s(_vm.schemes[1].discount)
                                    ),
                                    _c("span", [_vm._v("%")])
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "scheme-title" }, [
                                  _vm._v(_vm._s(_vm.schemes[1].title))
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "scheme-price" }, [
                                  _c("span", { staticClass: "price" }, [
                                    _vm.currency[_vm.priceLang].front
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.currency[_vm.priceLang].front
                                            )
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm._v(
                                      _vm._s(
                                        _vm.schemes[1].price[_vm.priceLang]
                                      )
                                    ),
                                    _vm.currency[_vm.priceLang].after
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.currency[_vm.priceLang].after
                                            )
                                          )
                                        ])
                                      : _vm._e()
                                  ]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "price-old" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.schemes[1].oldPrice[_vm.priceLang]
                                      )
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "scheme-type" }, [
                                  _vm._v(_vm._s(_vm.schemes[1].type))
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "scheme-btn" }, [
                                  _c(
                                    "button",
                                    {
                                      on: {
                                        click: function($event) {
                                          return _vm.openPage(1, _vm.schemes[1])
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "language.popup.worldBackupPopup.getOffer"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "scheme-tips" }, [
                                  _c("div", { staticClass: "scheme-tip" }, [
                                    _c("div", { staticClass: "point" }),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.schemes[1].tip) +
                                          "\n                                        "
                                      ),
                                      _c("div", { staticClass: "ask" }, [
                                        _c(
                                          "div",
                                          { staticClass: "plan-questionTxt" },
                                          [_vm._v(_vm._s(_vm.schemes[1].tipPs))]
                                        )
                                      ])
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "scheme-tip" }, [
                                    _c("div", { staticClass: "point" }),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "language.popup.worldBackupPopup.tips1"
                                          )
                                        ) +
                                          "\n                                        "
                                      ),
                                      _c("div", { staticClass: "ask" }, [
                                        _c(
                                          "div",
                                          { staticClass: "plan-questionTxt" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "language.popup.worldBackupPopup.ps1"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ])
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "scheme-tip" }, [
                                    _c("div", { staticClass: "point" }),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "language.popup.worldBackupPopup.tips2"
                                          )
                                        ) +
                                          "\n                                        "
                                      ),
                                      _c("div", { staticClass: "ask" }, [
                                        _c(
                                          "div",
                                          { staticClass: "plan-questionTxt" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "language.popup.worldBackupPopup.ps2"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ])
                                    ])
                                  ])
                                ])
                              ]
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.user.vip
                      ? _c(
                          "div",
                          {
                            staticClass: "timesale-scheme-body",
                            style: _vm.getHeight()
                          },
                          [
                            _c("div", { staticClass: "timesale-scheme-left" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "scheme-discount",
                                  style: _vm.getDiscountLeft(
                                    _vm.schemes[1].title,
                                    266
                                  )
                                },
                                [
                                  _vm._v("-" + _vm._s(_vm.schemes[1].discount)),
                                  _c("span", [_vm._v("%")])
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "scheme-title" }, [
                                _vm._v(_vm._s(_vm.schemes[1].title))
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "scheme-price" }, [
                                _c("span", { staticClass: "price" }, [
                                  _vm.currency[_vm.priceLang].front
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.currency[_vm.priceLang].front
                                          )
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(
                                        _vm.schemes[1].price[_vm.priceLang]
                                      ) +
                                      "\n                                    "
                                  ),
                                  _vm.currency[_vm.priceLang].after
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.currency[_vm.priceLang].after
                                          )
                                        )
                                      ])
                                    : _vm._e()
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "price-old" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.schemes[1].oldPrice[_vm.priceLang]
                                    )
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "scheme-type" }, [
                                _vm._v(_vm._s(_vm.schemes[1].type))
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "scheme-btn" }, [
                                _c(
                                  "button",
                                  {
                                    on: {
                                      click: function($event) {
                                        return _vm.openPage(1, _vm.schemes[1])
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "language.popup.worldBackupPopup.getOffer"
                                        )
                                      )
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "scheme-tips" }, [
                                _c("div", { staticClass: "scheme-tip" }, [
                                  _c("div", { staticClass: "point" }),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.schemes[1].tip) +
                                        "\n                                        "
                                    ),
                                    _c("div", { staticClass: "ask" }, [
                                      _c(
                                        "div",
                                        { staticClass: "plan-questionTxt" },
                                        [_vm._v(_vm._s(_vm.schemes[1].tipPs))]
                                      )
                                    ])
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "scheme-tip" }, [
                                  _c("div", { staticClass: "point" }),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "language.popup.worldBackupPopup.tips1"
                                        )
                                      ) +
                                        "\n                                        "
                                    ),
                                    _c("div", { staticClass: "ask" }, [
                                      _c(
                                        "div",
                                        { staticClass: "plan-questionTxt" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "language.popup.worldBackupPopup.ps1"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ])
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "scheme-tip" }, [
                                  _c("div", { staticClass: "point" }),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "language.popup.worldBackupPopup.tips2"
                                        )
                                      ) +
                                        "\n                                        "
                                    ),
                                    _c("div", { staticClass: "ask" }, [
                                      _c(
                                        "div",
                                        { staticClass: "plan-questionTxt" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "language.popup.worldBackupPopup.ps2"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ])
                                  ])
                                ])
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "timesale-scheme-line" }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "timesale-scheme-right" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "scheme-discount",
                                    style: _vm.getDiscountLeft(
                                      _vm.schemes[11].title,
                                      266
                                    )
                                  },
                                  [
                                    _vm._v(
                                      "-" + _vm._s(_vm.schemes[11].discount)
                                    ),
                                    _c("span", [_vm._v("%")])
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "scheme-title" }, [
                                  _vm._v(_vm._s(_vm.schemes[11].title))
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "scheme-price" }, [
                                  _c("span", { staticClass: "price" }, [
                                    _vm.currency[_vm.priceLang].front
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.currency[_vm.priceLang].front
                                            )
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm._v(
                                      _vm._s(
                                        _vm.schemes[11].price[_vm.priceLang]
                                      )
                                    ),
                                    _vm.currency[_vm.priceLang].after
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.currency[_vm.priceLang].after
                                            )
                                          )
                                        ])
                                      : _vm._e()
                                  ]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "price-old" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.schemes[11].oldPrice[_vm.priceLang]
                                      )
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "scheme-type" }, [
                                  _vm._v(_vm._s(_vm.schemes[11].type))
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "scheme-btn" }, [
                                  _c(
                                    "button",
                                    {
                                      on: {
                                        click: function($event) {
                                          return _vm.openPage(
                                            11,
                                            _vm.schemes[11]
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "language.popup.worldBackupPopup.getOffer"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "scheme-tips" }, [
                                  _c("div", { staticClass: "scheme-tip" }, [
                                    _c("div", { staticClass: "point" }),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.schemes[11].tip) +
                                          "\n                                        "
                                      ),
                                      _c("div", { staticClass: "ask" }, [
                                        _c(
                                          "div",
                                          { staticClass: "plan-questionTxt" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.schemes[11].tipPs)
                                            )
                                          ]
                                        )
                                      ])
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "scheme-tip" }, [
                                    _c("div", { staticClass: "point" }),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "language.popup.worldBackupPopup.tips1"
                                          )
                                        ) +
                                          "\n                                        "
                                      ),
                                      _c("div", { staticClass: "ask" }, [
                                        _c(
                                          "div",
                                          { staticClass: "plan-questionTxt" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "language.popup.worldBackupPopup.ps1"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ])
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "scheme-tip" }, [
                                    _c("div", { staticClass: "point" }),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "language.popup.worldBackupPopup.tips2"
                                          )
                                        ) +
                                          "\n                                        "
                                      ),
                                      _c("div", { staticClass: "ask" }, [
                                        _c(
                                          "div",
                                          { staticClass: "plan-questionTxt" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "language.popup.worldBackupPopup.ps2"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ])
                                    ])
                                  ])
                                ])
                              ]
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "vip-upgrade-tips" }, [
                      _vm.user.vip && _vm.nowSchemeName
                        ? _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("language.paySystem.vipUpgradeTips", {
                                  type: _vm.$t(_vm.nowSchemeName)
                                })
                              )
                            )
                          ])
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "timesale-scheme timesale-scheme-un" },
                    [
                      _c("div", { staticClass: "timesale-scheme-title" }, [
                        _c("div", [
                          _vm._v(
                            _vm._s(
                              "- " +
                                _vm.$t("language.paySystem.unlimitedData") +
                                " -"
                            )
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "timesale-scheme-body" }, [
                        _c("div", { staticClass: "timesale-scheme-left" }, [
                          _c(
                            "div",
                            {
                              staticClass: "scheme-discount",
                              style: _vm.getDiscountLeft(
                                _vm.schemes[2].title,
                                266
                              )
                            },
                            [
                              _vm._v("-" + _vm._s(_vm.schemes[2].discount)),
                              _c("span", [_vm._v("%")])
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "scheme-title" }, [
                            _vm._v(_vm._s(_vm.schemes[2].title))
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "scheme-price" }, [
                            _c("span", { staticClass: "price" }, [
                              _vm.currency[_vm.priceLang].front
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.currency[_vm.priceLang].front)
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(
                                _vm._s(_vm.schemes[2].price[_vm.priceLang])
                              ),
                              _vm.currency[_vm.priceLang].after
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.currency[_vm.priceLang].after)
                                    )
                                  ])
                                : _vm._e()
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "price-old" }, [
                              _vm._v(
                                _vm._s(_vm.schemes[2].oldPrice[_vm.priceLang])
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "scheme-type" }, [
                            _vm._v(_vm._s(_vm.schemes[2].type))
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "scheme-btn" }, [
                            _c(
                              "button",
                              {
                                on: {
                                  click: function($event) {
                                    return _vm.openPage(2, _vm.schemes[2])
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "language.popup.worldBackupPopup.getOffer"
                                    )
                                  )
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "scheme-tips" }, [
                            _c("div", { staticClass: "scheme-tip" }, [
                              _c("div", { staticClass: "point" }),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.schemes[2].tip) +
                                    "\n                                        "
                                ),
                                _c("div", { staticClass: "ask" }, [
                                  _c(
                                    "div",
                                    { staticClass: "plan-questionTxt" },
                                    [_vm._v(_vm._s(_vm.schemes[2].tipPs))]
                                  )
                                ])
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "scheme-tip" }, [
                              _c("div", { staticClass: "point" }),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "language.popup.worldBackupPopup.tips1"
                                    )
                                  ) +
                                    "\n                                        "
                                ),
                                _c("div", { staticClass: "ask" }, [
                                  _c(
                                    "div",
                                    { staticClass: "plan-questionTxt" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "language.popup.worldBackupPopup.ps1"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ])
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "scheme-tip" }, [
                              _c("div", { staticClass: "point" }),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "language.popup.worldBackupPopup.tips2"
                                    )
                                  ) +
                                    "\n                                        "
                                ),
                                _c("div", { staticClass: "ask" }, [
                                  _c(
                                    "div",
                                    { staticClass: "plan-questionTxt" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "language.popup.worldBackupPopup.ps2"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ])
                              ])
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "timesale-scheme-line" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "timesale-scheme-right" }, [
                          _c(
                            "div",
                            {
                              staticClass: "scheme-discount",
                              style: _vm.getDiscountLeft(
                                _vm.schemes[3].title,
                                266
                              )
                            },
                            [
                              _vm._v("-" + _vm._s(_vm.schemes[3].discount)),
                              _c("span", [_vm._v("%")])
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "scheme-title" }, [
                            _vm._v(_vm._s(_vm.schemes[3].title))
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "scheme-price" }, [
                            _c("span", { staticClass: "price" }, [
                              _vm.currency[_vm.priceLang].front
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.currency[_vm.priceLang].front)
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(
                                _vm._s(_vm.schemes[3].price[_vm.priceLang])
                              ),
                              _vm.currency[_vm.priceLang].after
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.currency[_vm.priceLang].after)
                                    )
                                  ])
                                : _vm._e()
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "price-old" }, [
                              _vm._v(
                                _vm._s(_vm.schemes[3].oldPrice[_vm.priceLang])
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "scheme-type" }, [
                            _vm._v(_vm._s(_vm.schemes[3].type))
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "scheme-btn" }, [
                            _c(
                              "button",
                              {
                                on: {
                                  click: function($event) {
                                    return _vm.openPage(3, _vm.schemes[3])
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "language.popup.worldBackupPopup.getOffer"
                                    )
                                  )
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "scheme-tips" }, [
                            _c("div", { staticClass: "scheme-tip" }, [
                              _c("div", { staticClass: "point" }),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.schemes[3].tip) +
                                    "\n                                        "
                                ),
                                _c("div", { staticClass: "ask" }, [
                                  _c(
                                    "div",
                                    { staticClass: "plan-questionTxt" },
                                    [_vm._v(_vm._s(_vm.schemes[3].tipPs))]
                                  )
                                ])
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "scheme-tip" }, [
                              _c("div", { staticClass: "point" }),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "language.popup.worldBackupPopup.tips1"
                                    )
                                  ) +
                                    "\n                                        "
                                ),
                                _c("div", { staticClass: "ask" }, [
                                  _c(
                                    "div",
                                    { staticClass: "plan-questionTxt" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "language.popup.worldBackupPopup.ps1"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ])
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "scheme-tip" }, [
                              _c("div", { staticClass: "point" }),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "language.popup.worldBackupPopup.tips2"
                                    )
                                  ) +
                                    "\n                                        "
                                ),
                                _c("div", { staticClass: "ask" }, [
                                  _c(
                                    "div",
                                    { staticClass: "plan-questionTxt" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "language.popup.worldBackupPopup.ps2"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "vip-upgrade-tips" }, [
                        _vm.user.vip && _vm.nowSchemeName
                          ? _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("language.paySystem.vipUpgradeTips", {
                                    type: _vm.$t(_vm.nowSchemeName)
                                  })
                                )
                              )
                            ])
                          : _vm._e()
                      ])
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "timesale-footer" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.$t("language." + _vm.flashSaledName + ".bottomTip")
                    ) +
                    "\n        "
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.contentYearyShow,
                  expression: "contentYearyShow"
                }
              ],
              staticClass: "timesale-content",
              class: "saled-bg-" + _vm.lang,
              style: "transform: scale(" + _vm.screenWidthRatio + ");",
              attrs: { id: "timeLimitedSaled", name: "timeSaledPopup" }
            },
            [
              _c("div", { staticClass: "timesale-top-close" }, [
                _c("div", {
                  staticClass: "discount_close",
                  staticStyle: { float: "center" },
                  on: {
                    click: function($event) {
                      return _vm.closePage()
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "discount_close-bg" }),
              _vm._v(" "),
              _c("div", { staticClass: "timesale-body" }, [
                _c(
                  "div",
                  {
                    staticClass: "timesale-schemes",
                    staticStyle: { "justify-content": "center" }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "timesale-scheme timesale-scheme-un" },
                      [
                        _c("div", { staticClass: "timesale-scheme-title" }, [
                          _c("div", [
                            _vm._v(
                              _vm._s(
                                "- " +
                                  _vm.$t("language.paySystem.unlimitedData") +
                                  " -"
                              )
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _vm.yearType == 0
                          ? _c(
                              "div",
                              {
                                staticClass: "timesale-scheme-body",
                                style: _vm.getHeight()
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "timesale-scheme-left" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "scheme-discount",
                                        style: _vm.getDiscountLeft(
                                          _vm.schemes[4].title,
                                          338
                                        )
                                      },
                                      [
                                        _vm._v(
                                          "-" + _vm._s(_vm.schemes[4].discount)
                                        ),
                                        _c("span", [_vm._v("%")])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "scheme-title" }, [
                                      _vm._v(_vm._s(_vm.schemes[4].title))
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "scheme-price" }, [
                                      _c("span", { staticClass: "price" }, [
                                        _vm.currency[_vm.priceLang].front
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.currency[_vm.priceLang]
                                                    .front
                                                )
                                              )
                                            ])
                                          : _vm._e(),
                                        _vm._v(
                                          _vm._s(
                                            _vm.schemes[4].price[_vm.priceLang]
                                          )
                                        ),
                                        _vm.currency[_vm.priceLang].after
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.currency[_vm.priceLang]
                                                    .after
                                                )
                                              )
                                            ])
                                          : _vm._e()
                                      ]),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "price-old" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.schemes[4].oldPrice[
                                              _vm.priceLang
                                            ]
                                          )
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "scheme-type" }, [
                                      _vm._v(_vm._s(_vm.schemes[4].type))
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "scheme-btn" }, [
                                      _c(
                                        "button",
                                        {
                                          on: {
                                            click: function($event) {
                                              return _vm.openPage(
                                                4,
                                                _vm.schemes[4]
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "language.popup.worldBackupPopup.getOffer"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "scheme-tips" }, [
                                      _c("div", { staticClass: "scheme-tip" }, [
                                        _c("div", { staticClass: "point" }),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(_vm.schemes[4].tip) +
                                              "\n                                        "
                                          ),
                                          _c("div", { staticClass: "ask" }, [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "plan-questionTxt"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.schemes[4].tipPs)
                                                )
                                              ]
                                            )
                                          ])
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "scheme-tip" }, [
                                        _c("div", { staticClass: "point" }),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "language.popup.worldBackupPopup.tips1"
                                              )
                                            ) +
                                              "\n                                        "
                                          ),
                                          _c("div", { staticClass: "ask" }, [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "plan-questionTxt"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "language.popup.worldBackupPopup.ps1"
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ])
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "scheme-tip" }, [
                                        _c("div", { staticClass: "point" }),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "language.popup.worldBackupPopup.tips2"
                                              )
                                            ) +
                                              "\n                                        "
                                          ),
                                          _c("div", { staticClass: "ask" }, [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "plan-questionTxt"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "language.popup.worldBackupPopup.ps2"
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ])
                                        ])
                                      ])
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", {
                                  staticClass: "timesale-scheme-line"
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "timesale-scheme-right" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "scheme-discount",
                                        style: _vm.getDiscountLeft(
                                          _vm.schemes[5].title,
                                          338
                                        )
                                      },
                                      [
                                        _vm._v(
                                          "-" + _vm._s(_vm.schemes[5].discount)
                                        ),
                                        _c("span", [_vm._v("%")])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "scheme-title" }, [
                                      _vm._v(_vm._s(_vm.schemes[5].title))
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "scheme-price" }, [
                                      _c("span", { staticClass: "price" }, [
                                        _vm.currency[_vm.priceLang].front
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.currency[_vm.priceLang]
                                                    .front
                                                )
                                              )
                                            ])
                                          : _vm._e(),
                                        _vm._v(
                                          _vm._s(
                                            _vm.schemes[5].price[_vm.priceLang]
                                          )
                                        ),
                                        _vm.currency[_vm.priceLang].after
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.currency[_vm.priceLang]
                                                    .after
                                                )
                                              )
                                            ])
                                          : _vm._e()
                                      ]),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "price-old" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.schemes[5].oldPrice[
                                              _vm.priceLang
                                            ]
                                          )
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "scheme-type" }, [
                                      _vm._v(_vm._s(_vm.schemes[5].type))
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "scheme-btn" }, [
                                      _c(
                                        "button",
                                        {
                                          on: {
                                            click: function($event) {
                                              return _vm.openPage(
                                                5,
                                                _vm.schemes[5]
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "language.popup.worldBackupPopup.getOffer"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "scheme-tips" }, [
                                      _c("div", { staticClass: "scheme-tip" }, [
                                        _c("div", { staticClass: "point" }),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(_vm.schemes[5].tip) +
                                              "\n                                        "
                                          ),
                                          _c("div", { staticClass: "ask" }, [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "plan-questionTxt"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.schemes[5].tipPs)
                                                )
                                              ]
                                            )
                                          ])
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "scheme-tip" }, [
                                        _c("div", { staticClass: "point" }),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "language.popup.worldBackupPopup.tips1"
                                              )
                                            ) +
                                              "\n                                        "
                                          ),
                                          _c("div", { staticClass: "ask" }, [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "plan-questionTxt"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "language.popup.worldBackupPopup.ps1"
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ])
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "scheme-tip" }, [
                                        _c("div", { staticClass: "point" }),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "language.popup.worldBackupPopup.tips2"
                                              )
                                            ) +
                                              "\n                                        "
                                          ),
                                          _c("div", { staticClass: "ask" }, [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "plan-questionTxt"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "language.popup.worldBackupPopup.ps2"
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ])
                                        ])
                                      ])
                                    ])
                                  ]
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.yearType == 1
                          ? _c(
                              "div",
                              {
                                staticClass: "timesale-scheme-body",
                                style: _vm.getHeight()
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "timesale-scheme-left" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "scheme-discount",
                                        style: _vm.getDiscountLeft(
                                          _vm.schemes[6].title,
                                          338
                                        )
                                      },
                                      [
                                        _vm._v(
                                          "-" + _vm._s(_vm.schemes[6].discount)
                                        ),
                                        _c("span", [_vm._v("%")])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "scheme-title" }, [
                                      _vm._v(_vm._s(_vm.schemes[6].title))
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "scheme-price" }, [
                                      _c("span", { staticClass: "price" }, [
                                        _vm.currency[_vm.priceLang].front
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.currency[_vm.priceLang]
                                                    .front
                                                )
                                              )
                                            ])
                                          : _vm._e(),
                                        _vm._v(
                                          _vm._s(
                                            _vm.schemes[6].price[_vm.priceLang]
                                          )
                                        ),
                                        _vm.currency[_vm.priceLang].after
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.currency[_vm.priceLang]
                                                    .after
                                                )
                                              )
                                            ])
                                          : _vm._e()
                                      ]),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "price-old" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.schemes[6].oldPrice[
                                              _vm.priceLang
                                            ]
                                          )
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "scheme-type" }, [
                                      _vm._v(_vm._s(_vm.schemes[6].type))
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "scheme-btn" }, [
                                      _c(
                                        "button",
                                        {
                                          on: {
                                            click: function($event) {
                                              return _vm.openPage(
                                                6,
                                                _vm.schemes[6]
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "language.popup.worldBackupPopup.getOffer"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "scheme-tips" }, [
                                      _c("div", { staticClass: "scheme-tip" }, [
                                        _c("div", { staticClass: "point" }),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(_vm.schemes[6].tip) +
                                              "\n                                        "
                                          ),
                                          _c("div", { staticClass: "ask" }, [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "plan-questionTxt"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.schemes[6].tipPs)
                                                )
                                              ]
                                            )
                                          ])
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "scheme-tip" }, [
                                        _c("div", { staticClass: "point" }),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "language.popup.worldBackupPopup.tips1"
                                              )
                                            ) +
                                              "\n                                        "
                                          ),
                                          _c("div", { staticClass: "ask" }, [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "plan-questionTxt"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "language.popup.worldBackupPopup.ps1"
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ])
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "scheme-tip" }, [
                                        _c("div", { staticClass: "point" }),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "language.popup.worldBackupPopup.tips2"
                                              )
                                            ) +
                                              "\n                                        "
                                          ),
                                          _c("div", { staticClass: "ask" }, [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "plan-questionTxt"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "language.popup.worldBackupPopup.ps2"
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ])
                                        ])
                                      ])
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", {
                                  staticClass: "timesale-scheme-line"
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "timesale-scheme-right" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "scheme-discount",
                                        style: _vm.getDiscountLeft(
                                          _vm.schemes[7].title,
                                          338
                                        )
                                      },
                                      [
                                        _vm._v(
                                          "-" + _vm._s(_vm.schemes[7].discount)
                                        ),
                                        _c("span", [_vm._v("%")])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "scheme-title" }, [
                                      _vm._v(_vm._s(_vm.schemes[7].title))
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "scheme-price" }, [
                                      _c("span", { staticClass: "price" }, [
                                        _vm.currency[_vm.priceLang].front
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.currency[_vm.priceLang]
                                                    .front
                                                )
                                              )
                                            ])
                                          : _vm._e(),
                                        _vm._v(
                                          _vm._s(
                                            _vm.schemes[7].price[_vm.priceLang]
                                          )
                                        ),
                                        _vm.currency[_vm.priceLang].after
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.currency[_vm.priceLang]
                                                    .after
                                                )
                                              )
                                            ])
                                          : _vm._e()
                                      ]),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "price-old" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.schemes[7].oldPrice[
                                              _vm.priceLang
                                            ]
                                          )
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "scheme-type" }, [
                                      _vm._v(_vm._s(_vm.schemes[7].type))
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "scheme-btn" }, [
                                      _c(
                                        "button",
                                        {
                                          on: {
                                            click: function($event) {
                                              return _vm.openPage(
                                                7,
                                                _vm.schemes[7]
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "language.popup.worldBackupPopup.getOffer"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "scheme-tips" }, [
                                      _c("div", { staticClass: "scheme-tip" }, [
                                        _c("div", { staticClass: "point" }),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(_vm.schemes[7].tip) +
                                              "\n                                        "
                                          ),
                                          _c("div", { staticClass: "ask" }, [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "plan-questionTxt"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.schemes[7].tipPs)
                                                )
                                              ]
                                            )
                                          ])
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "scheme-tip" }, [
                                        _c("div", { staticClass: "point" }),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "language.popup.worldBackupPopup.tips1"
                                              )
                                            ) +
                                              "\n                                        "
                                          ),
                                          _c("div", { staticClass: "ask" }, [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "plan-questionTxt"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "language.popup.worldBackupPopup.ps1"
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ])
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "scheme-tip" }, [
                                        _c("div", { staticClass: "point" }),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "language.popup.worldBackupPopup.tips2"
                                              )
                                            ) +
                                              "\n                                        "
                                          ),
                                          _c("div", { staticClass: "ask" }, [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "plan-questionTxt"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "language.popup.worldBackupPopup.ps2"
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ])
                                        ])
                                      ])
                                    ])
                                  ]
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.yearType == 2
                          ? _c(
                              "div",
                              {
                                staticClass: "timesale-scheme-body",
                                style: _vm.getHeight()
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "timesale-scheme-left" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "scheme-discount",
                                        style: _vm.getDiscountLeft(
                                          _vm.schemes[8].title,
                                          338
                                        )
                                      },
                                      [
                                        _vm._v(
                                          "-" + _vm._s(_vm.schemes[8].discount)
                                        ),
                                        _c("span", [_vm._v("%")])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "scheme-title" }, [
                                      _vm._v(_vm._s(_vm.schemes[8].title))
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "scheme-price" }, [
                                      _c("span", { staticClass: "price" }, [
                                        _vm.currency[_vm.priceLang].front
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.currency[_vm.priceLang]
                                                    .front
                                                )
                                              )
                                            ])
                                          : _vm._e(),
                                        _vm._v(
                                          _vm._s(
                                            _vm.schemes[8].price[_vm.priceLang]
                                          )
                                        ),
                                        _vm.currency[_vm.priceLang].after
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.currency[_vm.priceLang]
                                                    .after
                                                )
                                              )
                                            ])
                                          : _vm._e()
                                      ]),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "price-old" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.schemes[8].oldPrice[
                                              _vm.priceLang
                                            ]
                                          )
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "scheme-type" }, [
                                      _vm._v(_vm._s(_vm.schemes[8].type))
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "scheme-btn" }, [
                                      _c(
                                        "button",
                                        {
                                          on: {
                                            click: function($event) {
                                              return _vm.openPage(
                                                8,
                                                _vm.schemes[8]
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "language.popup.worldBackupPopup.getOffer"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "scheme-tips" }, [
                                      _c("div", { staticClass: "scheme-tip" }, [
                                        _c("div", { staticClass: "point" }),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(_vm.schemes[8].tip) +
                                              "\n                                        "
                                          ),
                                          _c("div", { staticClass: "ask" }, [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "plan-questionTxt"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.schemes[8].tipPs)
                                                )
                                              ]
                                            )
                                          ])
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "scheme-tip" }, [
                                        _c("div", { staticClass: "point" }),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "language.popup.worldBackupPopup.tips1"
                                              )
                                            ) +
                                              "\n                                        "
                                          ),
                                          _c("div", { staticClass: "ask" }, [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "plan-questionTxt"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "language.popup.worldBackupPopup.ps1"
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ])
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "scheme-tip" }, [
                                        _c("div", { staticClass: "point" }),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "language.popup.worldBackupPopup.tips2"
                                              )
                                            ) +
                                              "\n                                        "
                                          ),
                                          _c("div", { staticClass: "ask" }, [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "plan-questionTxt"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "language.popup.worldBackupPopup.ps2"
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ])
                                        ])
                                      ])
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", {
                                  staticClass: "timesale-scheme-line"
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "timesale-scheme-right" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "scheme-discount",
                                        style: _vm.getDiscountLeft(
                                          _vm.schemes[9].title,
                                          338
                                        )
                                      },
                                      [
                                        _vm._v(
                                          "-" + _vm._s(_vm.schemes[9].discount)
                                        ),
                                        _c("span", [_vm._v("%")])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "scheme-title" }, [
                                      _vm._v(_vm._s(_vm.schemes[9].title))
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "scheme-price" }, [
                                      _c("span", { staticClass: "price" }, [
                                        _vm.currency[_vm.priceLang].front
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.currency[_vm.priceLang]
                                                    .front
                                                )
                                              )
                                            ])
                                          : _vm._e(),
                                        _vm._v(
                                          _vm._s(
                                            _vm.schemes[9].price[_vm.priceLang]
                                          )
                                        ),
                                        _vm.currency[_vm.priceLang].after
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.currency[_vm.priceLang]
                                                    .after
                                                )
                                              )
                                            ])
                                          : _vm._e()
                                      ]),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "price-old" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.schemes[9].oldPrice[
                                              _vm.priceLang
                                            ]
                                          )
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "scheme-type" }, [
                                      _vm._v(_vm._s(_vm.schemes[9].type))
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "scheme-btn" }, [
                                      _c(
                                        "button",
                                        {
                                          on: {
                                            click: function($event) {
                                              return _vm.openPage(
                                                9,
                                                _vm.schemes[9]
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "language.popup.worldBackupPopup.getOffer"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "scheme-tips" }, [
                                      _c("div", { staticClass: "scheme-tip" }, [
                                        _c("div", { staticClass: "point" }),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(_vm.schemes[9].tip) +
                                              "\n                                        "
                                          ),
                                          _c("div", { staticClass: "ask" }, [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "plan-questionTxt"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.schemes[9].tipPs)
                                                )
                                              ]
                                            )
                                          ])
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "scheme-tip" }, [
                                        _c("div", { staticClass: "point" }),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "language.popup.worldBackupPopup.tips1"
                                              )
                                            ) +
                                              "\n                                        "
                                          ),
                                          _c("div", { staticClass: "ask" }, [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "plan-questionTxt"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "language.popup.worldBackupPopup.ps1"
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ])
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "scheme-tip" }, [
                                        _c("div", { staticClass: "point" }),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "language.popup.worldBackupPopup.tips2"
                                              )
                                            ) +
                                              "\n                                        "
                                          ),
                                          _c("div", { staticClass: "ask" }, [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "plan-questionTxt"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "language.popup.worldBackupPopup.ps2"
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ])
                                        ])
                                      ])
                                    ])
                                  ]
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "vip-upgrade-tips" }, [
                          _vm.user.vip && _vm.nowSchemeName
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "language.paySystem.vipUpgradeTips",
                                      { type: _vm.$t(_vm.nowSchemeName) }
                                    )
                                  )
                                )
                              ])
                            : _vm._e()
                        ])
                      ]
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "timesale-footer" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.$t("language." + _vm.flashSaledName + ".bottomTip")
                    ) +
                    "\n        "
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.contentUnlimiedActiveShow,
                  expression: "contentUnlimiedActiveShow"
                }
              ],
              staticClass: "timesale-content",
              class: "saled-bg-" + _vm.lang,
              style: "transform: scale(" + _vm.screenWidthRatio + ");",
              attrs: { id: "timeLimitedSaled", name: "timeSaledPopup" }
            },
            [
              _c("div", { staticClass: "timesale-top-close" }, [
                _c("div", {
                  staticClass: "discount_close",
                  staticStyle: { float: "center" },
                  on: {
                    click: function($event) {
                      return _vm.closePage()
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "discount_close-bg" }),
              _vm._v(" "),
              _c("div", { staticClass: "timesale-body" }, [
                _c(
                  "div",
                  {
                    staticClass: "timesale-schemes",
                    staticStyle: { "justify-content": "center" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "timesale-scheme timesale-scheme-un",
                        staticStyle: { width: "480px", margin: "23px 0 0 0" }
                      },
                      [
                        _c("div", { staticClass: "timesale-scheme-title" }, [
                          _c("div", [
                            _vm._v(
                              _vm._s(
                                "- " +
                                  _vm.$t("language.paySystem.unlimitedData") +
                                  " -"
                              )
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "timesale-scheme-body" }, [
                          _c(
                            "div",
                            {
                              staticClass: "timesale-scheme-right",
                              staticStyle: { width: "100%" }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "scheme-discount",
                                  style: _vm.getDiscountLeft(
                                    _vm.schemes[10].title,
                                    480
                                  )
                                },
                                [
                                  _vm._v(
                                    "-" + _vm._s(_vm.schemes[10].discount)
                                  ),
                                  _c("span", [_vm._v("%")])
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "scheme-title" }, [
                                _vm._v(_vm._s(_vm.schemes[10].title))
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "scheme-price" }, [
                                _c("span", { staticClass: "price" }, [
                                  _vm.currency[_vm.priceLang].front
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.currency[_vm.priceLang].front
                                          )
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(
                                    _vm._s(_vm.schemes[10].price[_vm.priceLang])
                                  ),
                                  _vm.currency[_vm.priceLang].after
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.currency[_vm.priceLang].after
                                          )
                                        )
                                      ])
                                    : _vm._e()
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "price-old" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.schemes[10].oldPrice[_vm.priceLang]
                                    )
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "scheme-type" }, [
                                _vm._v(_vm._s(_vm.schemes[10].type))
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "scheme-btn" }, [
                                _c(
                                  "button",
                                  {
                                    on: {
                                      click: function($event) {
                                        return _vm.openPage(10, _vm.schemes[10])
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "language.popup.worldBackupPopup.getOffer"
                                        )
                                      )
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "scheme-tips" }, [
                                _c("div", { staticClass: "scheme-tip" }, [
                                  _c("div", { staticClass: "point" }),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.schemes[10].tip) +
                                        "\n                                        "
                                    ),
                                    _c("div", { staticClass: "ask" }, [
                                      _c(
                                        "div",
                                        { staticClass: "plan-questionTxt" },
                                        [_vm._v(_vm._s(_vm.schemes[10].tipPs))]
                                      )
                                    ])
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "scheme-tip" }, [
                                  _c("div", { staticClass: "point" }),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "language.popup.worldBackupPopup.tips1"
                                        )
                                      ) +
                                        "\n                                        "
                                    ),
                                    _c("div", { staticClass: "ask" }, [
                                      _c(
                                        "div",
                                        { staticClass: "plan-questionTxt" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "language.popup.worldBackupPopup.ps1"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ])
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "scheme-tip" }, [
                                  _c("div", { staticClass: "point" }),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "language.popup.worldBackupPopup.tips2"
                                        )
                                      ) +
                                        "\n                                        "
                                    ),
                                    _c("div", { staticClass: "ask" }, [
                                      _c(
                                        "div",
                                        { staticClass: "plan-questionTxt" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "language.popup.worldBackupPopup.ps2"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ])
                                  ])
                                ])
                              ])
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "vip-upgrade-tips" }, [
                          _vm.user.vip && _vm.nowSchemeName
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "language.paySystem.vipUpgradeTips",
                                      { type: _vm.$t(_vm.nowSchemeName) }
                                    )
                                  )
                                )
                              ])
                            : _vm._e()
                        ])
                      ]
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "timesale-footer" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.$t("language." + _vm.flashSaledName + ".bottomTip")
                    ) +
                    "\n        "
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c("iosPayTipDialog", { ref: "iosPayTipDialog" })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4b83f5a9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b83f5a9","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/upgrade_popups/flash_saled_popup.vue
// module id = null
// module chunks = 